import cloneDeep from 'lodash/cloneDeep'
import unescape from 'lodash/unescape'
import AccountType from '@/constants/user/AccountType'
import Image from '@/models-ts/Image'
import Skill from '@/models-ts/Skill'
import Avatar from '@/models-ts/user/Avatar'
import { stripDescriptionTags } from '@/utils/contract'
import { parseSlug } from '@/utils/parser'

export default class GigShort {
  id: number
  slug: string
  type: number
  name: string
  banner: Image
  description: string
  skills: Array<Skill>
  rate: string
  timeType: number
  userId: number
  userType: AccountType
  userName: string
  avatar: Avatar
  avgReview: string
  userReviews: number

  constructor(data: GigShortProps) {
    Object.assign(
      this,
      cloneDeep({
        id: data.id,
        slug: parseSlug(data.slug),
        type: data.type,
        name: unescape(data.name),
        description: stripDescriptionTags(data.description),
        banner: Image.fromServer(data.banners, { maxSize: 609 }),
        userId: data.user_id,
        userName: unescape(data.userName),
        userType: data.userType,
        avatar: Avatar.fromServer(data.avatar),
        avgReview: Number(data.avgReview || 0).toFixed(2),
        userReviews: data.userReviews,
        skills: (data.skills || []).map(Skill.fromServer),
        rate: data.rate,
        timeType: data.timeType,
      })
    )
  }
}

export type GigShortProps = {
  id: number
  slug: string
  type: number
  name: string
  description: string
  banners: Array<LX.Image>
  skills: Array<LX.Skill>
  rate: string
  timeType: number
  user_id: number
  userName: string
  userType: AccountType
  avgReview: number
  userReviews: number
  avatar: LX.Avatar | LX.Avatar[]
}
